import styled from 'styled-components/macro';

export const DotsLoaderStyled = styled.div<{
  size: number;
  offsetX: string;
  offsetY: string;
  color: string;
}>`
  position: relative;
  width: ${({ size }): string => `${size}px`};
  height: ${({ size }): string => `${size}px`};

  border-radius: ${({ theme }): string => theme.radius.half};
  background-color: ${({ theme, color }): string =>
    color ? color : theme.colors.primary.variant1};
  color: ${({ theme }): string => theme.colors.primary.variant1};

  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;

  ${({ offsetY, offsetX }): string => `
    ${offsetY ? `margin-top: ${offsetY};` : ''}
    ${offsetX ? `left: ${offsetX};` : ''}
  `}

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: ${({ size }): string => `${-1.5 * size}px`};
    width: ${({ size }): string => `${size}px`};
    height: ${({ size }): string => `${size}px`};
    border-radius: ${({ theme }): string => theme.radius.half};
    background-color: ${({ theme, color }): string =>
      color ? color : theme.colors.primary.variant1};
    color: ${({ theme }): string => theme.colors.primary.variant1};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: ${({ size }): string => `${1.5 * size}px`};
    width: ${({ size }): string => `${size}px`};
    height: ${({ size }): string => `${size}px`};
    border-radius: ${({ theme }): string => theme.radius.half};
    background-color: ${({ theme, color }): string =>
      color ? color : theme.colors.primary.variant1};
    color: ${({ theme }): string => theme.colors.primary.variant1};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${({ theme, color }): string =>
        color ? color : theme.colors.primary.variant1};
    }
    ${({ theme }): string => theme.radius.half},
    100% {
      background-color: ${({ theme }): string => theme.colors.primary.variant2};
    }
  }
`;
